module.exports = __webpack_public_path__ + "media/images/smart_phone/gifu-49e3b5e619ad13a51adb57c54d1e2763.gif";